export default "https://cdn-static.gokick.com/assets/9232f824e6a46c896411df64bf74cb68df4bd809/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";